<template>
<div>
    <div class="page-header d-flex w-100">
        <div class="title-col d-flex w-50">
        <span class="title-icon">
          <b-icon-folder-fill></b-icon-folder-fill>
        </span>
        <span class="title-text">Tenant Details Screen</span>
      </div>
    </div>
    <div class="page-body">
    <kendo-panelbar id="panelbar" class="mt-3">
       <div id="item">
        <span class="tab-name">Tenant Details</span>
        <div>
        <div class="row">
        <div class="col-sm-3">
          <div class="form-group">
            <label class="label-section">Tenant Name:</label>
            <k-input
              :name="'Tenant Name'"
              class="w-100 rounded-border"
              :value="tenant && tenant.name ? tenant.name : 'N/A'"
              :readonly="true"
            />
          </div>
        </div>

        <div class="col-sm-3">
          <div class="form-group">
            <label class="label-section">Tenant Contact Name:</label>
            <k-input
              :name="'Tenant Contact Person'"
              class="w-100 rounded-border"
              :value="tenant && tenant.contactPerson ? tenant.contactPerson : 'N/A'"
              :readonly="true"
            />
          </div>
        </div>

        <div class="col-sm-3">
          <div class="form-group">
            <label class="label-section">Tenant Contact No:</label>
            <k-input
              :name="'Tenant Contact No'"
              class="w-100 rounded-border"
              :value="tenant && tenant.contactNo ? tenant.contactNo : 'N/A'"
              :readonly="true"
            />
          </div>
        </div>

        <div class="col-sm-3">
          <div class="form-group">
            <label class="label-section">Tenant Contact Email:</label>
            <k-input
              :name="'Contact Email'"
              class="w-100 rounded-border"
              :value="tenant && tenant.emailId ? tenant.emailId : 'N/A'"
              :readonly="true"
            />
          </div>
        </div>

        <div class="col-sm-3">
          <div class="form-group">
            <label class="label-section">Sub Domain Name:</label>
            <k-input
              :name="'Sub Domain Name '"
              class="w-100 rounded-border"
              :value="tenant && tenant.subDomain ? tenant.subDomain : 'N/A'"
              :readonly="true"
            />
          </div>
        </div>

        <div class="col-sm-3">
          <div class="form-group">
            <label class="label-section">Website:</label>
            <k-input
              :name="'Website'"
              class="w-100 rounded-border"
              :value="tenant && tenant.website ? tenant.website : 'N/A'"
              :readonly="true"
            />
          </div>
        </div>

        <div class="col-sm-3">
          <div class="form-group">
            <label class="label-section">Client:</label>
             <k-input
              :name="'Client'"
              class="w-100 rounded-border"
              :value="tenant && tenant.clientName ? tenant.clientName : 'N/A'"
              :readonly="true"
            />
          </div>
        </div>

        <div class="col-sm-3">
          <div class="form-group">
            <label class="label-section">Latitude:</label>
            <k-input
              :name="'Latitude'"
              class="w-100 rounded-border"
              :value="tenant && tenant.latitude ? tenant.latitude : 'N/A'"
              :readonly="true"
            />
          </div>
        </div>

        <div class="col-sm-3">
          <div class="form-group">
            <label class="label-section">Longitude:</label>
            <k-input
              :name="'Longitude'"
              class="w-100 rounded-border"
              :value="tenant && tenant.longitude ? tenant.longitude : 'N/A'"
              :readonly="true"
            />
          </div>
        </div>

      </div>
        </div>
       </div>
    </kendo-panelbar>

    <kendo-panelbar id="panelbar1" class="mt-3">
       <div id="item1">
           <span class="tab-name">User & Role</span>
        <div>
        <div class="row" v-for="user in tenantUser" :key="user.id">
            <div class="col-sm-3">
              <div class="form-group">
                <label class="label-section">Name:</label>
                <k-input :name="'Name'" :readonly="true" class="w-100 rounded-border" :value="user && user.name ? user.name : 'N/A'" />
              </div>
            </div>

            <div class="col-sm-3">
              <div class="form-group">
                <label class="label-section">Email:</label>
                <k-input
                  :name="'Email'"
                  class="w-100 rounded-border"
                  :readonly="true"
                  :value="user && user.email ? user.email : 'N/A'"
                />
              </div>
            </div>

            <div class="col-sm-3">
              <div class="form-group">
                <label class="label-section">Phone No:</label>
                <k-input
                  :name="'Phone No'"
                  class="w-100 rounded-border"
                  :readonly="true"
                  :value="user && user.mobileNo ? user.mobileNo : 'N/A'"
                />
              </div>
            </div>

            <div class="col-sm-3">
              <div class="form-group">
                <label class="label-section">Role:</label>
                <k-input
                  :name="'Role'"
                  class="w-100 rounded-border"
                  :readonly="true"
                  :value="user && user.roleName ? user.roleName : 'N/A'"
                />
              </div>
            </div>

          </div>
        </div>
       </div>
    </kendo-panelbar>

    <kendo-panelbar id="panelbar2" class="mt-3">
    <div id="item2">
        <span class="tab-name">Products, Packages & Add Ons</span>
        <div>
    <div class="row" v-for="product in tenantProductData" :key="product.id">
        <div class="col-sm-3">
          <div class="form-group">
            <label class="label-section">Product Name:</label>
            <k-input :name="'Product Name'" :readonly="true" class="w-100 rounded-border" :value="product && product.productName ? product.productName : 'N/A'" />
          </div>
        </div>

        <div class="col-sm-3">
          <div class="form-group">
            <label class="label-section">Packages:</label>
            <k-input
              :name="'Packages'"
              class="w-100 rounded-border"
              :readonly="true"
              :value="product && product.packageName ? product.packageName : 'N/A'"
            />
          </div>
        </div>

        <div class=" col-sm-3" v-if="product && product.packName && product.packName.modules && product.packName.modules.length>0">
          <div class="form-group">
            <label class="label-section">Features:</label>
            <div class="feature-list w-100 bg-white">
              <ul>
                <li
                  class="feature-list-view"
                  v-for="feature in product.packName.modules"
                  :key="feature.id"
                >
                  <span>{{ feature.name }}</span>
                </li>
              </ul>
            </div>
          </div>
          </div>

    </div>
        </div>
    </div>
    </kendo-panelbar>

    <kendo-panelbar id="panelbar3" class="mt-3">
    <div id="item3">
        <span class="tab-name">Assign Database</span>
        <div>
    <div class="row">
        <div class="col-sm-3">
          <div class="form-group">
            <label class="label-section">Name:</label>
            <k-input :name="'Name'" :readonly="true" class="w-100 rounded-border" :value="databaseData && databaseData.name ? databaseData.name : 'N/A'" />
          </div>
        </div>

        <div class="col-sm-3">
          <div class="form-group">
            <label class="label-section">Description:</label>
            <k-input
              :name="'Description'"
              class="w-100 rounded-border"
              :readonly="true"
              :value="databaseData && databaseData.description ? databaseData.description : 'N/A'"
            />
          </div>
        </div>

        <div class="col-sm-3">
          <div class="form-group">
            <label class="label-section">Database Details:</label>
            <k-input
              :name="'Database Details'"
              class="w-100 rounded-border"
              :readonly="true"
              :value="databaseData.isDefault == true ? 'Default': 'Dedicated'"
            />
          </div>
        </div>


    </div>

    <div class="row">
      <div class="col-sm-12">
        <div class="form-group" v-if="databaseData.configDBDetail && databaseData.configDBDetail.length>0">
          <label class="label-section">Database Configuration Details:</label>
          <b-table sticky-header :fields="fields" :items="databaseData.configDBDetail">
            <template v-if="databaseData.id" v-slot:cell(microserviceName)="config">{{config.item.microserviceName}}</template>
            <template v-slot:cell(connectionString)="config">
              <k-input
                class="w-100"
                style="width:5em"
                :value="config.item.connectionString"
                :readonly="true"
              />
            </template>
          </b-table>
        </div>
      </div>
    </div>
        </div>
    </div>
    </kendo-panelbar>
    </div>

    <div class="text-right">
      <button type="button" style="margin-right: 10px;" class="save-button btn btn-default ml-3 rounded-button-border" @click="close">Cancel</button>
    </div>
</div>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
import $ from "jquery";
const { mapState } = createNamespacedHelpers("onboarding");
export default {
    data: function() {
        return {
            fields: [
              { key: "microserviceName", sortable: true },
              { key: "connectionString" },
            ],
            tenant: {},
            tenantUser: {},
            tenantProductData: {},
            databaseData:{}
        }
    },
    methods: {
      expandPanel() {
      $("#panelbar").kendoPanelBar();
      var panelBar = $("#panelbar").data("kendoPanelBar");
      panelBar.expand($("#item"));

      $("#panelbar1").kendoPanelBar();
      var panelBar1 = $("#panelbar1").data("kendoPanelBar");
      panelBar1.expand($("#item1"));

      $("#panelbar2").kendoPanelBar();
      var panelBar2 = $("#panelbar2").data("kendoPanelBar");
      panelBar2.expand($("#item2"));

      $("#panelbar3").kendoPanelBar();
      var panelBar3 = $("#panelbar3").data("kendoPanelBar");
      panelBar3.expand($("#item3"));
      },
      close() {
      this.$router.go(-1); 
      },
      getDataonLoad() {
        let tenantData = this.$store.state.tenants;
        if(tenantData && tenantData.length>0) {
        this.tenant = tenantData.find(item =>item.id == this.$route.params.id);
        this.tenant.clientName = this.$store.state.clients.find(item =>item.id == this.tenant.clientId)?.name;
        }
        this.$store.dispatch("getRoles");
        if(this.tenantUsers && this.tenantUsers.length>0) {
          this.tenantUser = this.tenantUsers;
          console.log('Roles', this.$store.state.tenantRoles);
          this.tenantUser.forEach(data => {
            data.roleName= this.$store.state.tenantRoles.find(item =>  item.id == data.roles)?.roleName;
          });
        }
        if(this.tenantProduct && this.tenantProduct.length>0) {
          this.tenantProductData = this.tenantProduct;
        }
        this.databaseData = this.database;
      }
    },
    computed: {
    ...mapState(["tenantUsers", "tenantProduct", "database"]),
    },
    mounted() {
      this.getDataonLoad();
      this.expandPanel();
    }
}
</script>
<style scoped="scss">
.row {
  width: 99%;
  background-color: white;
  margin: 0 auto;
  padding: 30px 10px;
  display: flex !important;
  flex-wrap: wrap;
  flex-direction: row;
}
.rounded-border{
    border: 0 !important;
    padding: 0;
    font-size: 14px !important;
    font-weight: bold;
}
.label-section {
    font-size: 13px;
}
.tab-name {
  font-size: 15px;
}

.feature-list {
  height: 180px;
  margin-top: 1rem;
  overflow-y: scroll;
  border: 1px solid rgba(33, 37, 41, 0.15);
}

.feature-list ul {
  list-style: none;
  padding-left: 20px;
}

.feature-list li span {
  font-size: 14px;
  display: inline-block;
  margin-top: 10px;
}
.b-table-sticky-header {
    overflow-y: auto;
    border: 1px solid rgba(33, 37, 41, 0.15);
    margin-top: 1rem !important;
    max-height: 300px;
}
.rounded-button-border {
    border-radius: 5px;
    width: 150px;
    border-color: #0047b2;
    margin: 0px 20px 20px 20px;
}
</style>